<template>
<div class='vx-col w-full mt-4'>
    <vx-card class="mt-2">
        <div class="vx-row">
            <div class="vx-col w-full md:w-1/2 sm:w-1/1" style="border-right:solid 1px #e5e5e5">
                <div class="text-left cursor-pointer">
                    <div class="vx-card__collapsible-content vs-con-loading__container">
                        <div class="vx-card__body">
                            <h4 class="mb-2">Datos personales</h4>
                            <p><b>Cédula: </b> {{usuario.cedula}}</p><br>
                            <p><b>Email: </b> {{usuario.email}}</p><br>
                            <p><b>Teléfono: </b> {{usuario.telefono}}</p><br>
                            <p><b>Fecha nacimiento: </b> {{usuario.f_nacimiento}}
                                <span v-if="no_birthday" class="text-danger">
                                    complete su fecha de nacimiento
                                </span>
                            </p><br>
                            <p><b>Fecha de registro: </b> {{usuario.fecha_create}}</p><br>

                        </div>
                    </div>
                </div>
            </div>
            <div class="vx-col w-full md:w-1/2 sm:w-1/1">
                <div class="text-left">
                    <div class="vx-card__collapsible-content vs-con-loading__container">
                        <div class="vx-card__body">
                            <h4 class="mb-2">Institución</h4>
                            <p><b>Nombre: </b> {{institucion.nombreInstitucion}}</p><br>
                            <template v-if="institucion.region == 1">
                                <p><b>Región: </b> Sierra</p><br>
                            </template>
                            <template v-else>
                                <p><b>Región: </b> Costa</p><br>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
            <div class="vx-col w-full md:w-1/2 sm:w-1/1 mb-base" style="border-right:solid 1px #e5e5e5">
                <vs-button type="relief" to="/perfil">Editar</vs-button>
            </div>
        </div>
    </vx-card>
</div>
</template>

<script>
export default {
    name: "VerPerfil",
    components: {},
    data() {
        return {
            usuario: '',
            institucion: '',
            no_birthday: false,
        };
    },
    created() {},
    mounted() {
        let me = this;
        this.usuario = JSON.parse(localStorage.getItem('usuario'))[0];
        this.getInstitucion();
        if (me.usuario.f_nacimiento === undefined || me.usuario.f_nacimiento === null) {
            me.no_birthday = true;
        }
    },
    methods: {
        getInstitucion() {
            let me = this;
            me.$vs.loading();
            me.$http.get(this.$server_url + 'institucion/' + this.usuario.institucion_idInstitucion)
                .then(function (response) {
                    me.institucion = response.data
                    me.$vs.loading.close();
                })
                .catch(function () {
                    me.$vs.loading.close();
                })
        },
        getProvincias() {
            let me = this;
            me.$vs.loading();
            me.$http.get(this.$server_url + 'provincias')
                .then(function (response) {
                    me.provincias = response.data
                    me.$vs.loading.close();
                })
                .catch(function () {
                    me.$vs.loading.close();

                })
        }
    }
};
</script>./viewPerfil.vue
